<div class="credit-dialog-title app-dialog-header" mat-dialog-title>
    <div>
        <h2 class="app-dialog-title">Buy credits</h2>
        <p class="app-dialog-subtitle">Select a PAYG credit pack to continue to secure checkout.</p>
    </div>
    <button class="dialog-close" type="button" aria-label="Close credit packs" (click)="closeDialog()">
        <mat-icon>close</mat-icon>
    </button>
</div>

<div mat-dialog-content class="credit-dialog-content">
    @if (error) {
        <div class="credit-error" role="alert">{{ error }}</div>
    }
    @if (loading) {
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    } @else if (offers.length) {
        <p>Pack prices are in GBP. Credits are charged once per new pin; ordinary follow-up histories, edits, defect completion and sign-off are included.</p>
        @if (catalogue?.grandfathering_ends_at) {
            <p>Your protected prices apply until {{ catalogue.grandfathering_ends_at | date:'longDate' }}. After protection ends, current PAYG applies unless you have an active Pro subscription.</p>
        }
        @if (catalogue?.usage?.uses_credits === false) {
            <p>Your subscription includes survey usage without spending credits.</p>
        }
        <div class="credit-offers">
            @for (offer of offers; track offer.price_id) {
                <button class="credit-offer" type="button" (click)="checkout(offer)" [disabled]="working">
                    <strong>{{ offer.amount / 100 | currency:offer.currency.toUpperCase():'symbol':'1.2-2' }}</strong>
                    <span class="credit-quantity">{{ offer.credit_quantity | number }} credits</span>
                    <span>{{ taxLabel(offer.tax_behavior) }}</span>
                    @if (offer.credit_quantity) {
                        <span>{{ offer.amount / offer.credit_quantity / 100 | currency:offer.currency.toUpperCase():'symbol':'1.2-4' }} per credit</span>
                    }
                    @if (discountPercent(offer); as discount) {
                        <span class="credit-discount">Save {{ discount }}% per credit</span>
                    }
                    @for (example of usageExamples(offer); track example.label) {
                        <span>{{ example.label }}: {{ example.credits }} {{ example.credits === 1 ? 'credit' : 'credits' }} ≈ {{ example.amount | currency:offer.currency.toUpperCase():'symbol':'1.2-4' }} per new pin</span>
                    }
                    <span class="credit-action">Buy</span>
                </button>
            }
        </div>
        <p>Examples use each pack’s price and VAT basis, with no extra charge. Savings compare with your 250-credit pack.</p>
    } @else {
        <p>No PAYG credit packs are currently available. Please try again later.</p>
    }
</div>
